"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const vue_1 = tslib_1.__importDefault(require("vue"));
const siteText_1 = tslib_1.__importDefault(require("../../mixins/siteText"));
const sitetext_1 = require("../../filters/sitetext");
const ChallengeStatus_1 = require("../../enums/ChallengeStatus");
const ElementIds_1 = require("../../enums/ElementIds");
const SlideHeaderWithNav_vue_1 = tslib_1.__importDefault(require("../SlideHeaderWithNav.vue"));
const ContainerSlide_vue_1 = tslib_1.__importDefault(require("../ContainerSlide.vue"));
const IsotopeHeader_vue_1 = tslib_1.__importDefault(require("../IsotopeHeader.vue"));
const userTelemetry_1 = require("../../api/userTelemetry");
exports.default = vue_1.default.extend({
    name: 'create-username',
    data: () => {
        return {
            inputValue: '',
            submitting: false,
            username: '',
            errors: [],
        };
    },
    computed: {
        baseUrl() {
            return this.$store.state.configuration.baseUrl;
        },
        isMobile() {
            return this.$store.getters.isMobile;
        },
        getSubheading() {
            return this.getSiteText('Registration.CreateUsername.SubHeading', this.usernameMinLength, this.usernameMaxLength);
        },
        buttonDisabled() {
            return this.submitting || !this.isValidUsername;
        },
        suggestedUsernames() {
            var _a;
            if (((_a = this.$store.state.currentChallenge.SuggestedUsernames) === null || _a === void 0 ? void 0 : _a.length) > 0)
                return this.$store.state.currentChallenge.SuggestedUsernames;
            return [];
        },
        showSuggestedUsernames() {
            return this.suggestedUsernames.length > 0;
        },
        hasExceededTries() {
            return this.$store.state.currentChallenge.HasExceededTries;
        },
        usernameSuggestionHeading() {
            if (this.hasExceededTries === true)
                return this.getSiteText('Registration.CreateUsername.Suggestions.Exceeded');
            return this.getSiteText('Registration.CreateUsername.Suggestions');
        },
        usernameRegex() {
            return new RegExp(this.$store.state.currentChallenge.UsernameRegex);
        },
        usernameMinLength() {
            return this.$store.state.currentChallenge.UsernameMinLength;
        },
        usernameMaxLength() {
            return this.$store.state.currentChallenge.UsernameMaxLength;
        },
        isValidUsername() {
            return this.username.length >= this.usernameMinLength && this.username.length <= this.usernameMaxLength
                && this.usernameRegex.test(this.username) && this.errors.length === 0;
        },
        elementIds: () => ElementIds_1.ElementIds,
    },
    mixins: [siteText_1.default],
    filters: {
        sitetext: sitetext_1.siteTextFilter,
    },
    methods: {
        validateBlur(ev) {
            const input = ev.target.value;
            this.validateUsername(input);
        },
        validateUsername(val) {
            // don't validate if the input is disabled
            if (this.hasExceededTries)
                return;
            this.username = '';
            if (val.length === 0) {
                this.errors = [this.getSiteText('Registration.CreateUsername.Input.Required')];
                return;
            }
            if (val.length < this.usernameMinLength || val.length > this.usernameMaxLength) {
                this.errors = [this.getSiteText('Registration.CreateUsername.Input.InvalidLength', this.usernameMinLength, this.usernameMaxLength)];
                return;
            }
            if (!this.usernameRegex.test(val)) {
                this.errors = [this.getSiteText('Registration.CreateUsername.Input.Invalid')];
                return;
            }
            this.username = val;
            this.errors = [];
            return true;
        },
        chooseUsername(val) {
            this.username = val;
            this.inputValue = val;
            this.errors = [];
        },
        async submitForm() {
            if (this.submitting) {
                return;
            }
            this.submitting = true;
            // store off whether the username is generated for telemetry purposes prior to submitting the request
            const triesExceeded = this.hasExceededTries;
            // reset the challenge status before submitting so we pick up a new one
            this.$store.commit('challengeStatus', ChallengeStatus_1.ChallengeStatus.Unknown);
            this.$store.commit('setUserName', this.username);
            const challenge = {
                ...this.$store.state.currentChallenge,
                Username: this.username,
            };
            // submit the challenge
            await this.$store.dispatch('submitChallenge', challenge);
            this.submitting = false;
            void userTelemetry_1.telemetry.custom({
                workflowName: userTelemetry_1.workflowName.retail_registration,
                stepType: userTelemetry_1.stepType.progression,
                stepName: userTelemetry_1.stepName.create_username,
                action: userTelemetry_1.userAction.create_username_clicked,
                eventProperties: {
                    'isAvailable': this.$store.state.currentChallenge.IsAvailable === false ? false : true,
                    'usernameType': triesExceeded === true ? 'generated' : 'custom',
                },
            });
            if (this.$store.state.currentChallenge.IsAvailable === false)
                this.errors = [this.getSiteText('Registration.CreateUsername.Input.Unavailable')];
        },
    },
    components: {
        SlideHeaderWithNav: SlideHeaderWithNav_vue_1.default,
        ContainerSlide: ContainerSlide_vue_1.default,
        IsotopeHeader: IsotopeHeader_vue_1.default,
    },
});
